import { render, staticRenderFns } from "./fEedback.vue?vue&type=template&id=23bc1b32&scoped=true"
import script from "./fEedback.vue?vue&type=script&lang=js"
export * from "./fEedback.vue?vue&type=script&lang=js"
import style0 from "./fEedback.vue?vue&type=style&index=0&id=23bc1b32&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc1b32",
  null
  
)

export default component.exports